// Dependencies
import React, { useState, useEffect, useRef, useCallback, useContext } from "react";

import { ReactSVG } from "react-svg";
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { CSSTransitionProps } from "react-transition-group/CSSTransition";
import { Portal } from 'react-portal';

// Types
import { Types, Components } from '../types';

// Utils
import { WP_PLUGIN_BASE_PATH } from '../utils/config'

// Hooks
import { useDebug } from "../hooks";
 
// Components
import { MinicartContext } from "../contexts/Minicart";
import CartItem from "./CartItem";
import Overlay from "./Overlay";

const SidebarItems = ({ className  }: any) => { 
    
    useDebug('SidebarItems'); 

    // Contexts
    const { updating, loading, itemsCount, items, config, translations, theme } = useContext( MinicartContext );
    const itemsRef = useRef<any>(null);

    const transitionProps: CSSTransitionProps = React.useMemo(() => ({
        in: itemsCount > 0,
        timeout: Number(theme.general.transition.duration.replace('ms', '')),
      }), [itemsCount, theme.general.transition.duration])
    
    return (<>
        <TransitionGroup component="div" className={`${className}${updating ? ' is-updating' : ''}${loading ? ' is-loading' : ''}`}>
            <Overlay
                height={itemsRef?.current?.scrollHeight ?? 0}
                isPortaled={false}
                className={[`${className}__overlay`]}
                isVisible={updating}
                disableScrollWhenVisible={false}
            />
            <div className={`${className}__wrapper`} ref={itemsRef}>
                {Object.entries(items).map(([cartItemID, item]: any) => (
                    <CSSTransition key={cartItemID} {...transitionProps}>
                        <CartItem className={'wooptima-cart-item'} {...{...item, cartItemID}} />
                    </CSSTransition>
                )
                )}
            </div>
        </TransitionGroup>
    </>)
}

export default SidebarItems;